var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAE232",
    strokeWidth: 1.5,
    d: "m3.4 6.118.408-.47h9.648v11.32l-.448.516-.407.468H2.953V6.632l.448-.514Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE232",
    fillRule: "evenodd",
    d: "m7.56 3.009.184-.211H16.3v10.29l-.264.302-.183.211h-.455v1.5h1.138l.632-.726.632-.727V1.298H7.06l-.631.726-.632.727v.947h1.5v-.386l.264-.303Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGold);
export default __webpack_public_path__ + "static/media/copy-gold.bf184b3bb514db6764dc4ab1101cf8ee.svg";
export { ForwardRef as ReactComponent };